module.exports = __webpack_public_path__ + "not_registered_avatar.svg?8f0df1b9f422cc0bc87bc439e983e963";